<template>
    <div class="page-wrapper">
        <div id="innerContainer" class="page-inner">
            <aside class="page-sidebar" :class="{ 'mobile-side-bar': isMobileNavToggle, 'mobile-sidebar-wide': !isMobileNavToggleWide }">
                <nav class="primary-nav" role="navigation">
                    <div class="info-card">
                        <img :src="getProfileImageUrl()" class="profile-image rounded-circle" v-bind:alt="profile">
                        <div class="info-card-text">
                            <a href="#" class="d-flex align-items-center text-white">
                                <span class="text-truncate-sm d-inline-block">
                                    {{ profile }}
                                </span>
                                <!-- <i class="fas fa-angle-down d-inline-block ml-1 fs-lg color-primary-300"></i> -->
                            </a>
                            <span>
                                <small>{{ $t('nav.welcome') }}, {{ userName }}</small>
                            </span>
                        </div>
                        <img src="@/assets/css/img/card-backgrounds/cover-5-lg.jpg" class="cover" alt="cover">
                    </div>
                    <ul id="nav-menu" class="nav-menu js-nav-built">
                        <li v-for="sideNav in sideNavs" :key="sideNav.listId">
                            <router-link v-if="sideNav.id === 'navDashboard'" :id="sideNav.id" class="waves-effect waves-themed"
                                :to="'/dashboard/dashboard_info2'" @click.native="hideSideNav('subMenu')">
                                <i class="fas" :class="sideNav.icon"></i>
                                <span class="nav-link-text">{{ sideNav.text || $t(`sideNav.${sideNav.id}`) }}</span>
                            </router-link>
                            <router-link v-else-if="sideNav.subMenus.length === 0" :id="sideNav.id" class="waves-effect waves-themed"
                                :to="'/dashboard/' + sideNav.url" @click.native="hideSideNav('subMenu')">
                                <i class="fas" :class="sideNav.icon"></i>
                                <span class="nav-link-text">{{ sideNav.text || sideNav.title || $t(`sideNav.${sideNav.id}`)}}</span>
                            </router-link>
                            <a v-else :id="sideNav.id" class="waves-effect waves-themed" @click="handleSideNav($event, 'subMenu')">
                                <i class="fas" :class="sideNav.icon"></i>
                                <span class="nav-link-text">{{ sideNav.text || $t(`sideNav.${sideNav.id}`) }}</span>
                                <i class="navIcon fal fa-angle-down"></i>
                            </a>
                            <ul class="subMenu">
                                <li v-for="subMenu in sideNav.subMenus" :key="subMenu.id">
                                    <a v-if="subMenu._subMenus.length > 0" :id="subMenu.id" class="waves-effect waves-themed"
                                        @click="subMenu._subMenus.length > 0 ? handleSideNav($event, 'subMenuChild') : ''">
                                        <span class="nav-link-text">{{ $t(`subMenu.${subMenu.url}`) }}</span>
                                        <i class="navIcon fal fa-angle-down"></i>
                                    </a>
                                    <router-link v-else :id="subMenu.id" class="waves-effect waves-themed" :to="'/dashboard/' + subMenu.url"
                                        @click.native="hideSideMenu">
                                        <span class="nav-link-text">{{ $t(`subMenu.${subMenu.url}`) }}</span>
                                        <b-badge pill variant="danger" class="ml-2" v-if="subMenu.newTag">New</b-badge>
                                    </router-link>
                                    <ul class="subMenuChild">
                                        <li v-for="_subMenu in subMenu._subMenus" :key="_subMenu.id">
                                            <router-link class="waves-effect waves-themed" :to="'/dashboard/' + subMenu.url + '/' + _subMenu.url"
                                                @click.native="hideSideMenu">
                                                <span class="nav-link-text">{{ $t(`brand_submenu.${_subMenu.url}`) }}</span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <router-link id="logout" to="/login" title="Log Out" @click.native="logout">
                                <i class="fas fa-sign-out-alt"></i>
                                <span class="nav-link-text text-uppercase">{{ $t('nav.logout') }}</span>
                            </router-link>
                        </li>
                    </ul>
                </nav>
            </aside>
            <div class="page-content-wrapper" :class="{ 'mobile-content-wide': !isMobileNavToggleWide }">
                <header class="page-header">
                    <!-- <div class="hidden-lg-up"> -->
                    <div class="">
                        <a class="header-btn btn press-scale-down waves-effect waves-themed" data-class="mobile-nav-on"
                            @click="onMobileNavToggle">
                            <i class="ni ni-menu"></i>
                        </a>
                    </div>
                    <div class="ml-auto d-flex">
                        <div>
                            <a class="header-icon" @click="handleNavToggle(true)">
                                <i class="fal fa-globe"></i>
                                <span class="badge badge-icon text-uppercase">{{ $i18n.locale }}</span>
                            </a>
                            <div v-show="langToggle" class="dropdown-menu dropdown-sm nav-dropdown-menu right-13 p-0">
                                <a class="dropdown-item" @click="setLang('en')">
                                    <flag iso="gb" class="mr-2" />English
                                </a>
                                <div class="dropdown-divider m-0"></div>
                                <a class="dropdown-item" @click="setLang('cn')">
                                    <flag iso="cn" class="mr-2" />简体中文
                                </a>
                                <div class="dropdown-divider m-0"></div>
                                <a class="dropdown-item" @click="setLang('tw')">
                                    <flag iso="tw" class="mr-2" />繁体中文
                                </a>
                                <div class="dropdown-divider m-0"></div>
                                <a class="dropdown-item" @click="setLang('bm')">
                                    <flag iso="my" class="mr-2" />Bahasa Malaysia
                                </a>
                                <div class="dropdown-divider m-0"></div>
                            </div>
                        </div>
                        <div>
                            <a class="header-icon d-flex align-items-center justify-content-center ml-2" @click="handleNavToggle(false)">
                                <img :src="getProfileImageUrl()" class="profile-image rounded-circle" v-bind:alt="profile">
                                <span class="ml-1 mr-1 text-truncate text-truncate-header hidden-xs-down">{{ userName }}</span>
                                <i class="ni ni-chevron-down hidden-xs-down"></i>
                            </a>
                            <div v-show="navToggle" class="dropdown-menu dropdown-md nav-dropdown-menu p-0">
                                <div class="dropdown-header bg-trans-gradient d-flex flex-row py-3 rounded-top">
                                    <div class="d-flex flex-row align-items-center mt-1 mb-1 color-white">
                                        <div class="info-card-text">
                                            <div class="fs-lg text-truncate text-truncate-lg">{{ profile }}</div>
                                            <span class="text-truncate text-truncate-md opacity-80">{{ userName }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dropdown-divider m-0"></div>
                                <!-- <a href="#" class="dropdown-item">
                                    <span>View Shop</span>
                                </a> -->
                                <!-- <router-link to="/dashboard/change_password" class="dropdown-item" title="Change Password"
                                    @click.native="navToggle = false">
                                    <span>{{ $t('nav.changePassword') }}</span>
                                </router-link> -->
                                <!-- <router-link to="/dashboard/change_loyalty_password" class="dropdown-item" :title="$t('nav.change_loyalty_password')"
                                    @click.native="navToggle = false">
                                    <span>{{ $t('nav.change_loyalty_password') }}</span>
                                </router-link> -->
                                <div class="dropdown-divider m-0"></div>
                                <router-link to="/login" class="dropdown-item" title="Logout" @click.native="logout">
                                    <span>{{ $t('nav.logout') }}</span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </header>
                <main id="page-content" role="main" class="page-content" @click="isMobileNavToggle = false">
                    <router-view></router-view>
                </main>
                <div class="shortcut-menu">
                    <a id="btnToTop" ref="btnToTop" @click="scrollToTop(1500)"
                        class="btn btn-primary btn-lg btn-icon rounded-circle waves-effect waves-themed scroll-up">
                        <i class="fas fa-angle-up"></i>
                    </a>
                </div>
            </div>
        </div>
        <div :class="{ 'show': isModalShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        <i class="fas fa-2x" :class="isError ? ['fa-exclamation-circle', 'text-danger'] : ['fa-check-circle', 'text-success']"></i>
                        <p class="ml-3 mb-0" :class="isError ? ['text-danger'] : ['text-dark']" v-html="message"></p>
                    </div>
                    <div class="modal-footer">
                        <button id="modalClose" type="button" class="btn btn-primary waves-effect waves-themed" @click="closeModal()">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal modal-alert" id="sessionExpiredModal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('session_expired.header') }}</h5>
                    </div>
                    <div class="modal-body">{{ $t('session_expired.description') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cst from './../assets/js/dashboard/nav'
import('@/assets/css/dashboard/dashboard.css')
import PosIntegration from '@/assets/js/dashboard/pos_integration'

import { getStateList, getOutletList, getCategoryList, getBreadCrumbs, getStaffList, idbOpen, setMemberList, getMemberMap } from './../assets/js/dashboard/dashboard'

export default {
    data() {
        return {
            isMobileNavToggle: false,
            isMobileNavToggleWide: true,
            langToggle: false, navToggle: false,
            navLinkID: "", renderPage: localStorage.path,
            isError: false, isModalShow: false, message: "",
            token: this.$util.getSessionToken(),
            profile: "",
            userName: "",
            sideNavs: cst.sideNavs,
            childComponent: {},
            langs: ['en', 'cn'],
            delta: 0,
            offset: 0,
            limit: 10000,
            db: null,
            memberList: []
        }
    },
    methods: {
        onMobileNavToggle() {
            if(window.innerWidth > 1200) {
                this.isMobileNavToggle = this.isMobileNavToggleWide = !this.isMobileNavToggleWide
            } else {
                this.isMobileNavToggle = this.isMobileNavToggleWide = !this.isMobileNavToggle
            }
        },
        logout() {
            localStorage.clear();
            this.$session.clear();
            this.$store.commit('RESET_STATE');
            localStorage.removeItem('token')
            localStorage.removeItem('userName')

            if (window.memberDB) {
                window.memberDB.close()
                delete window.memberDB
            }
        },
        getProfileImageUrl() {
            return this.$store.state.icon;
        },
        closeModal() {
            this.isModalShow = false;
            this.childComponent.closeModal(this.isError);
        },
        setModal($vm, isError, isModalShow, message) {
            document.getElementById('modalClose').style.visibility = '';
            this.message = message;
            this.isError = isError;
            this.isModalShow = isModalShow;
            this.childComponent = $vm;
        },
        setLang(lang) {
            this.$i18n.locale = lang
            this.langToggle = false
        },
        handleNavToggle(isLang) {
            if (isLang) {
                this.navToggle = false
                this.langToggle = !this.langToggle
            } else {
                this.langToggle = false
                this.navToggle = !this.navToggle
            }
        },
        hideSideMenu() {
            if (this.isMobileNavToggle) {
                this.isMobileNavToggle = false
            }
        },
        hideSideNav(_class) {
            var _subMenu = document.getElementsByClassName(_class);

            for (var j = 0; j < _subMenu.length; j++) {
                _subMenu[j].classList.remove('show');
            }

            var _icon = document.getElementsByClassName('navIcon');
            for (var i = 0; i < _icon.length; i++) {
                _icon[i].classList.remove('fa-angle-up');
                _icon[i].classList.add('fa-angle-down');
            }
        },
        handleSideNav(e, _class) {
            var subMenu = document.getElementById(e.currentTarget.id).nextSibling;
            var icon = document.getElementById(e.currentTarget.id).lastChild;

            if (subMenu.classList.contains('show')) {
                subMenu.classList.remove('show');

                icon.classList.remove('fa-angle-up');
                icon.classList.add('fa-angle-down');

            } else {
                var _subMenu = document.getElementsByClassName(_class);

                for (var j = 0; j < _subMenu.length; j++) {
                    _subMenu[j].classList.remove('show');
                }
                subMenu.classList.add('show');

                var _icon = document.getElementsByClassName('navIcon');
                for (var i = 0; i < _icon.length; i++) {
                    _icon[i].classList.remove('fa-angle-up');
                    _icon[i].classList.add('fa-angle-down');
                }

                icon.classList.remove('fa-angle-down');
                icon.classList.add('fa-angle-up');
            }
        },
        scrollToTop(duration) {
            const totalScrollDistance = document.scrollingElement.scrollTop;
            let scrollY = totalScrollDistance, oldTimestamp = null;

            function step(newTimestamp) {
                if (oldTimestamp !== null) {
                    scrollY -= totalScrollDistance * (newTimestamp - oldTimestamp) / duration;
                    if (scrollY <= 0) return document.scrollingElement.scrollTop = 0;
                    document.scrollingElement.scrollTop = scrollY;
                }
                oldTimestamp = newTimestamp;
                window.requestAnimationFrame(step);
            }
            window.requestAnimationFrame(step);
        },
        setBlockList() {
            var allSideNavs = cst.sideNavs.map(a => ({ ...a }));

            var arrBlock = []
            for (var i = 0; i < this.$store.state.blockList.length; i++) {
                arrBlock.push(getBreadCrumbs(this, this.$store.state.blockList[i]))
            }

            for (var j = 0; j < arrBlock.length; j++) {
                if (Object.prototype.hasOwnProperty.call(arrBlock[j].subMenu[0], 'text')) {
                    if (arrBlock[j].subMenu[0].text == "[ALL]") {
                        allSideNavs = allSideNavs.filter(item => item.id !== arrBlock[j].id)
                    } else {
                        for (var k = 0; k < arrBlock[j].subMenu.length; k++) {
                            for (var l = 0; l < allSideNavs.length; l++) {
                                allSideNavs[l].subMenus = allSideNavs[l].subMenus.filter(itm => itm.id !== arrBlock[j].subMenu[k].id)
                            }
                        }
                    }
                }
            }

            allSideNavs.forEach(element => {
                if (element.subMenus.length == 1) {
                    element.title = element.text || this.$i18n.t(element.subMenus[0].title);
                    element.id = element.subMenus[0].id;
                    element.url = element.subMenus[0].url;
                    element.subMenus = []
                }
            });

            let whitelist = [
                "kw@tunai",
                "tammy@tunai",
                "dayon.salon@tunai",
                "tommy@tunai",
                "kevin@tunai",
                "simon@tunai",
                "chloe.salon@tunai",
                "simon.salon@tunai",
            ]
            if (window.location.href.includes('devbusiness') || window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                // if(whitelist.includes(this.$store.state.userName)) {
                let subMenus = []
                subMenus.push({ id: 'salon_setting_landing', title: 'Package', url: 'salon_setting_landing', _subMenus: [], newTag: false })
                subMenus.push({ id: 'salon_report_stock3', title: 'Stock', url: 'salon_report_stock3', _subMenus: [], newTag: false })

                // let userName = localStorage.getItem('userName')
                // if(userName === 'kw@tunai' || userName === 'huuk@tunai' || userName === 'tommy@tunai') {
                //     subMenus.push({ id: 'my_salon_member4', title: 'Member', url: 'my_salon_member4' , _subMenus:[], newTag:false })
                // }

                if (cst.sideNavs[0]['listId'] !== 99) {
                    allSideNavs.unshift({
                        listId: 99,
                        id: "navBeta",
                        title: "BETA",
                        subMenus: subMenus,
                        icon: "fa-vial"
                    })
                }
            }

            let userName = localStorage.getItem('userName').toLowerCase()

            let listId = 1000


            PosIntegration.POS_INTEGRATION_LIST.forEach(k => {
                if (k['account'].includes(userName)) {
                    allSideNavs.push({
                        listId: listId++,
                        id: "nav" + k['outlet'],
                        text: k['name'],
                        // subMenus: subMenus,
                        // subMenus: [{ id: 'salon_' + k['outlet'], text: k['name'], url: k['outlet'], _subMenus: [], newTag: false }],
                        subMenus: [],
                        url: k['outlet'],
                        icon: "fa-upload"
                    })
                }
            })


            let commissionAccount

            if (userName === 'kw@tunai'
                || userName === 'tommy@tunai'
                || userName === 'wenawave@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_wenawave_sales', title: 'Sales', url: 'salon_wenawave_sales', _subMenus: [], newTag: false },
                    { id: 'salon_wenawave_commission', title: 'Commission', url: 'salon_wenawave_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navWenawave",
                    text: "WENAWAVE",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai'
                || userName === 'dayon@tunai'
                || userName === 'auraq7@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_auraq7_sales', title: 'Sales', url: 'salon_auraq7_sales', _subMenus: [], newTag: false },
                    { id: 'salon_auraq7_commission', title: 'Commission', url: 'salon_auraq7_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navAuraQ7",
                    title: "Aura Q7",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai'
                || userName === 'tommy@tunai'
                || userName === 'aria.wellness@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_ariawellness_sales', title: 'Sales', url: 'salon_ariawellness_sales', _subMenus: [], newTag: false },
                    { id: 'salon_ariawellness_commission', title: 'Commission', url: 'salon_ariawellness_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navAriaWellness",
                    title: "Aria Wellness",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai'
                || userName === 'tommy@tunai'
                || userName === 'lawawax@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_lawawax_sales', title: 'Sales', url: 'salon_lawawax_sales', _subMenus: [], newTag: false },
                    { id: 'salon_lawawax_commission', title: 'Commission', url: 'salon_lawawax_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navLawaWax",
                    title: "LawaWax",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai' 
                || userName === 'frank.auto@tunai' 
                || userName === 'bianco@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_bianco_sales', title: 'Sales', url: 'salon_bianco_sales', _subMenus: [], newTag: false },
                    { id: 'salon_bianco_commission', title: 'Commission', url: 'salon_bianco_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navBianco",
                    title: "白Bianco by Mei Ng",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai'
                || userName === 'tommy@tunai'
                || userName === 'regalbeaute@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_regal_beaute_sales', title: 'Sales', url: 'salon_regal_beaute_sales', _subMenus: [], newTag: false },
                    { id: 'salon_regal_beaute_commission', title: 'Commission', url: 'salon_regal_beaute_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navRegalBeaute",
                    title: "RegalBeaute",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai' 
                || userName === 'frank.auto@tunai' 
                || userName === 'yeejian.auto@tunai' 
                || userName === 'zenth.cheras@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_zenth_sales', title: 'Sales', url: 'salon_zenth_sales', _subMenus: [], newTag: false },
                    { id: 'salon_zenth_commission', title: 'Commission', url: 'salon_zenth_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navZenth",
                    title: "Zenth",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai' 
                || userName === 'rayray@tunai'
            ) {
                let subMenus = [
                    { id: 'salon_estrella_sales', title: 'Sales', url: 'salon_estrella_sales', _subMenus: [], newTag: false },
                    { id: 'salon_estrella_commission', title: 'Commission', url: 'salon_estrella_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navEstrella",
                    title: "Estrella",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', 'qistina@tunai', "nimroc@tunai", "nimroc.maluri@tunai", "nimroc.dk@tunai", "nimroc.sa@tunai", "nimroc.dp@tunai", "nimroc.dagang@tunai", "nimroc.kd@tunai", "nimroc.klem@tunai", "nimroc.wm@tunai", "nimroc.ttdi@tunai", "nimroc.bangsar@tunai", "nimroc.sb@tunai", "nimroc.desapandan@tunai", "nimroc.st@tunai", "nimroc.elmina@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_nimroc_sales', title: 'Sales', url: 'salon_nimroc_sales', _subMenus: [], newTag: false },
                    { id: 'salon_nimroc_commission', title: 'Commission', url: 'salon_nimroc_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navNimroc",
                    title: "Nimroc",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', "rex@tunai", 'rex.auto@tunai', 'sevenhair@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_seven_hair_studio_sales', title: 'Sales', url: 'salon_seven_hair_studio_sales', _subMenus: [], newTag: false },
                    { id: 'salon_seven_hair_studio_commission', title: 'Commission', url: 'salon_seven_hair_studio_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navSevenHairStudio",
                    title: "Seven Hair Studio",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            if (userName === 'kw@tunai'
                || userName === "frank.auto@tunai"
                || userName === "theone.only@tunai"
            ) {
                let subMenus = [
                    { id: 'salon_the_one_only_fitness_sales', title: 'Sales', url: 'salon_the_one_only_fitness_sales', _subMenus: [], newTag: false },
                    { id: 'salon_the_one_only_fitness_commission', title: 'Commission', url: 'salon_the_one_only_fitness_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navTheOneOnlyFitness",
                    title: "The One Only Fitness",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', "chloe.salon@tunai", "oriya@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_oriya_sales', title: 'Sales', url: 'salon_oriya_sales', _subMenus: [], newTag: false },
                    { id: 'salon_oriya_commission', title: 'Commission', url: 'salon_oriya_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navOriya",
                    title: "Oriya",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', "rayray@tunai", 'd.asia@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_dasiawellness_sales', title: 'Sales', url: 'salon_dasiawellness_sales', _subMenus: [], newTag: false },
                    { id: 'salon_dasiawellness_commission', title: 'Commission', url: 'salon_dasiawellness_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navDAsiaWellness",
                    title: "D Asia Wellness",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', "chloe.salon@tunai", 'jn.southkey@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_JNSkin_sales', title: 'Sales', url: 'salon_JNSkin_sales', _subMenus: [], newTag: false },
                    { id: 'salon_JNSkin_commission', title: 'Commission', url: 'salon_JNSkin_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navJNSkin",
                    title: "JNSkin",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', "chloe.salon@tunai", 'enchanted@tunai', "frank.auto@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_EnchantedSibling_sales', title: 'Sales', url: 'salon_EnchantedSibling_sales', _subMenus: [], newTag: false },
                    { id: 'salon_EnchantedSibling_commission', title: 'Commission', url: 'salon_EnchantedSibling_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navEnchantedSibling",
                    title: "Enchanted Sibling",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }
            
            commissionAccount = ['kw@tunai', "dayon.salon@tunai", "dayon@tunai", 'viiskinn@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_VIISkin_sales', title: 'Sales', url: 'salon_VIISkin_sales', _subMenus: [], newTag: false },
                    { id: 'salon_VIISkin_commission', title: 'Commission', url: 'salon_VIISkin_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navVIISkin",
                    title: "VIISkin",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', "rayray@tunai", "nail.mi@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_NailMiStudio_sales', title: 'Sales', url: 'salon_NailMiStudio_sales', _subMenus: [], newTag: false },
                    { id: 'salon_NailMiStudio_commission', title: 'Commission', url: 'salon_NailMiStudio_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navNailMiStudio",
                    title: "Nail Mi Studio",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', 'tommy@tunai', 'combcut@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_CombAndCut_sales', title: 'Sales', url: 'salon_CombAndCut_sales', _subMenus: [], newTag: false },
                    { id: 'salon_CombAndCut_commission', title: 'Commission', url: 'salon_CombAndCut_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navCombAndCut",
                    title: "Comb & Cut",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', 'frank.auto@tunai', "chloe.salon@tunai", "thenail.edge@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_TheNailEdge_sales', title: 'Sales', url: 'salon_TheNailEdge_sales', _subMenus: [], newTag: false },
                    { id: 'salon_TheNailEdge_commission', title: 'Commission', url: 'salon_TheNailEdge_commission', _subMenus: [], newTag: false },
                    { id: 'salon_TheNailEdge_commission_system', title: 'Commission', url: 'salon_TheNailEdge_commission_system', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navTheNailEdge",
                    title: "Comb & Cut",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', 'chloe.salon@tunai', "oriental.pav1@tunai", "oriental.pav@tunai", "oriental.fahrenheit@tunai", "oriental.fahrenheit1@tunai", "oriental.intermark@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_OrientalSpa_sales', title: 'Sales', url: 'salon_OrientalSpa_sales', _subMenus: [], newTag: false },
                    { id: 'salon_OrientalSpa_commission', title: 'Commission', url: 'salon_OrientalSpa_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navOrientalSpa",
                    title: "Oriental Spa",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', 'tommy@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_Unifit_sales', title: 'Sales', url: 'salon_Unifit_sales', _subMenus: [], newTag: false },
                    { id: 'salon_Unifit_commission', title: 'Commission', url: 'salon_Unifit_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navUnifit",
                    title: "Unifit",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            commissionAccount = ['kw@tunai', 'chloe.salon@tunai', "frank.auto@tunai", "philo.headspa@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_PhiloHeadspa_sales', title: 'Sales', url: 'salon_PhiloHeadspa_sales', _subMenus: [], newTag: false },
                    { id: 'salon_PhiloHeadspa_commission', title: 'Commission', url: 'salon_PhiloHeadspa_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navPhiloHeadspa",
                    title: "Philo Headspa",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }

            
            commissionAccount = ['kw@tunai', "dayon@tunai", 'organicway@tunai', 'organicway.bugis@tunai', 'organicway.sengkang@tunai', 'organicway.sengkang1@tunai']
            // commissionAccount = ['kw@tunai', "dayon@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_OrganicWay_sales', title: 'Sales', url: 'salon_OrganicWay_sales', _subMenus: [], newTag: false },
                    { id: 'salon_OrganicWay_commission', title: 'Commission', url: 'salon_OrganicWay_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navOrganicWay",
                    title: "Organic Way",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }


            // commissionAccount = ['kw@tunai', 'chloe.salon@tunai', "frank.auto@tunai", "philo@tunai"]
            // if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
            //     commissionAccount.push("frank.auto@tunai")
            // }
            // if (commissionAccount.includes(userName)) {
            //     let subMenus = [
            //         { id: 'salon_PhiloHairStudio_sales', title: 'Sales', url: 'salon_PhiloHairStudio_sales', _subMenus: [], newTag: false },
            //         { id: 'salon_PhiloHairStudio_commission', title: 'Commission', url: 'salon_PhiloHairStudio_commission', _subMenus: [], newTag: false },
            //     ]

            //     allSideNavs.push({
            //         listId: listId++,
            //         id: "navPhiloHairStudio",
            //         title: "Philo Hair Studio (August 2024)",
            //         subMenus: subMenus,
            //         icon: "fa-star"
            //     })
            // }


            commissionAccount = ['kw@tunai', 'chloe.salon@tunai', "frank.auto@tunai", "philo@tunai"]
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_PhiloHairStudioSkudai_sales', title: 'Sales', url: 'salon_PhiloHairStudioSkudai_sales', _subMenus: [], newTag: false },
                    { id: 'salon_PhiloHairStudioSkudai_commission', title: 'Commission', url: 'salon_PhiloHairStudioSkudai_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navPhiloHairStudioSkudai",
                    title: "Philo Hair Studio (Skudai)",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }


            commissionAccount = ['kw@tunai', 'dayon@tunai', 'ak@tunai']
            commissionAccount = ['kw@tunai', 'dayon@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_AKHair_sales', title: 'Sales', url: 'salon_AKHair_sales', _subMenus: [], newTag: false },
                    { id: 'salon_AKHair_commission', title: 'Commission', url: 'salon_AKHair_commission', _subMenus: [], newTag: false },
                    { id: 'salon_AKHair_payment', title: 'Payment', url: 'salon_AKHair_payment', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navAKHair",
                    title: "AK Hair Studio",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }


            commissionAccount = ['kw@tunai', 'chloe.salon@tunai', 'miroku.hair@tunai', 'miroku.bangsar@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_Miroku_staff', title: 'Staff', url: 'salon_Miroku_staff', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navMiroku",
                    title: "Miroku",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }


            commissionAccount = ['kw@tunai', 'chloe.salon@tunai', 'oriya.tp@tunai']
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                commissionAccount.push("frank.auto@tunai")
                commissionAccount.push("oriya@tunai")
            }
            if (commissionAccount.includes(userName)) {
                let subMenus = [
                    { id: 'salon_OriyaBeautyTaiping_sales', title: 'Sales', url: 'salon_OriyaBeautyTaiping_sales', _subMenus: [], newTag: false },
                    { id: 'salon_OriyaBeautyTaiping_commission', title: 'Commission', url: 'salon_OriyaBeautyTaiping_commission', _subMenus: [], newTag: false },
                ]

                allSideNavs.push({
                    listId: listId++,
                    id: "navOriyaBeautyTaiping",
                    title: "Oriya Beauty Taiping",
                    subMenus: subMenus,
                    icon: "fa-star"
                })
            }
            

            this.sideNavs = allSideNavs
        },
    }
    ,
    async mounted() {
        let $vm = this;
        $vm.profile = $vm.$store.state.shopName;
        $vm.userName = $vm.$store.state.userName;

        getOutletList($vm);
        getStaffList($vm);
        getCategoryList($vm);
        getStateList($vm);
        // let dbName = $vm.$store.state.userName+"_memberList";
        // $vm.db = await idbOpen(dbName,"member_list");
        // setMemberList($vm);
        // getMemberMap($vm);

        $vm.setBlockList()

        var btnToTop = document.getElementById('btnToTop');
        window.onscroll = function () {
            document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? btnToTop.style.display = "block" : btnToTop.style.display = "none";
        }
    }
}


</script>
<style scoped>
.header-icon {
    cursor: pointer;
}

.nav-dropdown-menu {
    right: 0;
    left: auto;
}

.show {
    display: block !important;
}

.subMenu:before {
    content: "";
    display: block;
    position: absolute;
    z-index: 1;
    left: 2.5625rem;
    top: 44px;
    bottom: 0;
    border-left: 1px solid #614b82;
}

.subMenu>li a:after {
    content: "";
    display: block;
    position: absolute;
    width: .4rem;
    height: .4rem;
    background-color: #876fab;
    left: 2.4rem;
    top: calc(50% - .3rem);
    border: 1px solid #333;
    border-radius: 50%;
    z-index: 1;
}

.subMenu>li a:hover:after {
    background-color: #ffffff;
}

.scroll-up {
    display: none;
}

.fa-angle-up {
    color: #ffffff;
}


@media only screen and (max-width: 1200px) {
    .mobile-side-bar {
        -webkit-transform: translate3d(0, 0, 0) !important;
        transform: translate3d(0, 0, 0) !important;
        border-right: 1px solid rgba(0, 0, 0, .03);
        -webkit-box-shadow: 0 3px 35px 3px rgba(0, 0, 0, .52);
        box-shadow: 0 3px 35px 3px rgba(0, 0, 0, .52);
    }
}

@media (min-width: 992px) {
    .right-13 {
        right: 13em !important;
    }
}</style>